import { Component } from '@angular/core';

@Component({
  selector: 'app-auto-suggestion-search',
  templateUrl: './auto-suggestion-search.component.html',
  styleUrls: ['./auto-suggestion-search.component.css']
})
export class AutoSuggestionSearchComponent {

}
